import { render, staticRenderFns } from "./videoPage.html?vue&type=template&id=67e72f5d&"
import script from "./videoPage.vue?vue&type=script&lang=js&"
export * from "./videoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports